import { DeclaracaoRecibimentoDto, ResponseDeclaracaoRecibimentoDto } from "../shared/dtos/Declaracao-anual-voluntaria.dto";
import api from "./api";
class DeclaracaoContribuicaoService {
  async gerarDeclaracao(
    idContribuinte: number,
    anoInicio: string,
    anoFim?: string 
  ): Promise<ResponseDeclaracaoRecibimentoDto | null> {
    const data: DeclaracaoRecibimentoDto = {
      idContribuinte: idContribuinte,
      anoInicial: anoInicio,
      anoFinal: anoFim || ""
    }
    const response = await api.post(
      `/ficha-financeira/get-data-relatorio-declaracao-anual-voluntaria`,
      {
        data,
        timeout: 0,
      }
    );
    return response.data;
  }

}

export default new DeclaracaoContribuicaoService();